import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/client";
import { useWishlist } from "../context/WishlistContext";
import { ProductGridSkeleton } from "../components/Skeletons";
import ProductCard from "../components/ProductCard";
import { Heart } from "lucide-react";

export default function Wishlist() {
    const { ids } = useWishlist();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                if (ids.length === 0) {
                    setProducts([]);
                    return;
                }
                const { data } = await api.get("/products");
                setProducts(data.filter((p) => ids.includes(p.id)));
            } finally {
                setLoading(false);
            }
        })();
    }, [ids]);

    return (
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 animate-fade-slide">
            <h1 className="font-heading font-black text-4xl md:text-6xl tracking-tighter mb-10">Your wishlist</h1>
            {loading ? (
                <ProductGridSkeleton count={4} />
            ) : products.length === 0 ? (
                <div data-testid="empty-wishlist" className="bg-white border border-brand-line rounded-3xl p-12 text-center">
                    <Heart size={48} className="mx-auto text-brand-moss mb-4" />
                    <h2 className="font-heading font-black text-3xl mb-3">Your wishlist is empty</h2>
                    <p className="text-brand-moss mb-8">Tap the heart on any product to save it here.</p>
                    <Link to="/products" className="inline-block bg-brand-orange text-white font-bold px-8 py-4 rounded-xl btn-lift">
                        Explore products
                    </Link>
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                    {products.map((p) => <ProductCard key={p.id} product={p} />)}
                </div>
            )}
        </div>
    );
}
